import { Modal } from "@general-backoffice/core/index";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";

const earningsProgress = [
  {
    minFriends: 1,
    maxFriends: 5,
    earn: 50,
  },
  {
    minFriends: 6,
    maxFriends: 10,
    earn: 75,
  },
  {
    minFriends: 11,
    maxFriends: 20,
    earn: 100,
  },
];

interface InfoModalProps {
  isOpen: boolean;
  close: () => void;
}

const InfoModal = ({ isOpen, close }: InfoModalProps) => {
  const { t } = useTranslation("referrer", { keyPrefix: "default.infoModal" });

  return (
    <Modal.Simple isOpen={isOpen} toggleOpen={close} size="lg" title={t("title")} closeText={t("closeText")}>
      <div className="mx--4">
        <Container fluid className="text-center">
          <Row className="flex-center flex-column py-5 text-default">
            <Col xs="auto" style={{ fontSize: "4rem" }}>
              <i className="fas fa-users"></i>
            </Col>
            <Col xs="auto" className="display-4 mb-3">
              {t("section1.title")}
            </Col>
            <Col xs={"auto"} className="h3 text-dark opacity-7">
              {t("section1.subtitle")}
            </Col>
          </Row>
          <Row className="flex-center flex-column bg-light py-5">
            <Col xs="auto" className="display-4 mb-3">
              {t("section2.title")}
            </Col>
            <Col xs={"auto"} className="h3 text-dark opacity-7 mb-4">
              {t("section2.subtitle")}
            </Col>
            <Col xs={11} className="mb-4">
              <Row className="justify-content-center" style={{ rowGap: "1rem" }}>
                {earningsProgress.map(({ minFriends, maxFriends, earn }, index) => {
                  return (
                    <Col xs={12} lg={4} key={index}>
                      <Trans
                        t={t}
                        i18nKey={"section2.box"}
                        values={{ minFriends, maxFriends, amount: earn }}
                        components={{
                          box: <div className="bg-white p-4" />,
                          strong: <strong />,
                          success: <span className="text-success" />,
                          hr: <hr className="my-3" />,
                          div: <div />,
                          bigText: <span className="display-2 text-default" style={{ lineHeight: "3rem" }} />,
                        }}
                      />
                    </Col>
                  );
                })}
              </Row>
            </Col>
            <Col xs={"auto"} className="h3 text-dark opacity-7">
              {t("section2.pendingRecommendations")}
            </Col>
          </Row>
          <Row className="py-5" style={{ rowGap: "1rem" }}>
            <Col xs={12} className="display-4 mb-3">
              {t("section3.title")}
            </Col>
            <Col>
              <div style={{ fontSize: "5rem" }} className="text-default">
                <i className="fas fa-link"></i>
              </div>
              <p>{t("section3.step1")}</p>
            </Col>
            <Col xs="auto" style={{ fontSize: "3rem" }} className="text-light flex-center">
              <i className="fas fa-chevron-right"></i>
            </Col>
            <Col>
              <div style={{ fontSize: "5rem" }} className="text-default">
                <i className="fas fa-share-alt"></i>
              </div>
              <p>{t("section3.step2")}</p>
            </Col>
          </Row>
          <Row className="py-5 bg-light" style={{ rowGap: "1rem" }}>
            <Col xs={12} className="display-4 mb-3">
              {t("section4.title")}
            </Col>
            <Col>
              <div style={{ fontSize: "5rem" }} className="text-default">
                <i className="fas fa-hand-holding-usd"></i>
              </div>
              <p>{t("section4.step1")}</p>
            </Col>
            <Col xs="auto" style={{ fontSize: "3rem" }} className="text-default flex-center">
              <i className="fas fa-chevron-right"></i>
            </Col>
            <Col>
              <div style={{ fontSize: "5rem" }} className="text-default">
                <i className="fas fa-chart-line"></i>
              </div>
              <p>{t("section4.step2")}</p>
            </Col>
          </Row>
          <Row className="flex-center flex-column py-5">
            <Col xs="auto" className="display-4 mb-3">
              {t("section5.title")}
            </Col>
            <Col xs={"auto"} className="h3 text-dark opacity-7">
              {t("section5.text")}
            </Col>
          </Row>
        </Container>
      </div>
    </Modal.Simple>
  );
};

export default InfoModal;
